import { RatePackageBulkUpsertGuard } from './rate-package-bulk-upsert.guard';

export const guards: any[] = [RatePackageBulkUpsertGuard];

export * from './rate-package-bulk-upsert.guard';